import React from 'react';
import Seo from '../components/common/Seo';
import PageHero from '../components/common/PageHero';
import { seo } from '@/data/seo';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Seo {...seo.terms} />
      <PageHero
        eyebrow="Legal"
        title="Terms of Service"
        description="Terms of use for the MAYAN Technology website."
      />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-gray-600 leading-relaxed">
          <p>
            Content on this website describes MAYAN Technology’s services and solutions for general information. It is not a contractual offer unless confirmed in writing.
          </p>
          <p>
            Partner and client logos remain the property of their respective owners and are shown to indicate published commercial relationships.
          </p>
          <p>
            We may update these pages as our published capabilities change. Continued use of the site means you accept the current wording.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
